"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapValues = function (input, fn) {
    var result = {};
    for (var key in input) {
        result[key] = fn(input[key]);
    }
    return result;
};
var warn = function (_message) { };
exports.warn = warn;
if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
    exports.warn = warn = function (message) {
        console.error("[redux-compact][warning] " + message);
    };
}
